/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-24 17:31:50
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-27 19:58:35
 * @FilePath: /wemeet-admin-new/src/views/recruitment/helper.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import { SALARY_SCALE } from './context'

export function salaryLabel(row) {
  if (row.isSalaryNegotiable) return '面议'
  const scale = SALARY_SCALE[row.settlementType]
  return `${row.minSalary / scale}-${row.maxSalary / scale}${row.salaryUnit}${
    row.monthSalarySystem > 12 ? `·${row.monthSalarySystem}薪` : ''
  }`
}

export function locationFormatter(str) {
  try {
    const { province, city, area } = JSON.parse(str)
    const location = []
    if (province) location.push(province)
    if (city && city !== province && city !== '直辖市') location.push(city)
    if (area) location.push(area)
    return location.join(' / ')
  } catch (error) {
    return ''
  }
}

export function ruleFormatter({ ruleType, ruleDayValue, rulePeopleValue }) {
  let str = ''
  if (ruleType === 'CUMULATIVE') {
    str = `累计推荐 ${rulePeopleValue} 人，`
  } else if (ruleType === 'URGENT') {
    str = `急招，`
  }
  if (ruleDayValue) str += `入职满 ${ruleDayValue} 天`
  else str = str.slice(0, -1)
  return str || '当天入职'
}
